import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=d2f5a0a0&scoped=true&"
import script from "./Crm.vue?vue&type=script&lang=js&"
export * from "./Crm.vue?vue&type=script&lang=js&"
import style0 from "./Crm.vue?vue&type=style&index=0&id=d2f5a0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f5a0a0",
  null
  
)

export default component.exports